export const localesWithInches = ["en-ca", "fr-ca", "en-us", "es-us"];
